import * as types from './types';
import { OrderRevenueEntity } from 'src/firebase/db/Orders';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
// import { ValidationResponse } from "src/firebase/db/ValidationManager";

export type Actions = GetMonthRevenue | SuccessGetMonthRevenue | FailGetMonthRevenue | InitRevenue;

/**
 * Get
 */
interface GetMonthRevenue {
  type: typeof types.GET_MONTH_REVENUE;
  payload: {
    shopId: string;
    startDate: Date;
    endDate: Date;
  };
}
export const getMonthRevenue = (payload: GetMonthRevenue['payload']) => ({
  type: types.GET_MONTH_REVENUE,
  payload,
});

interface SuccessGetMonthRevenue {
  type: typeof types.SUCCESS_GET_MONTH_REVENUE;
  payload: APISuccessfulResponse<OrderRevenueEntity>;
}

export const successGetMonthRevenue = (payload: SuccessGetMonthRevenue['payload']) => ({
  type: types.SUCCESS_GET_MONTH_REVENUE,
  payload,
});

interface FailGetMonthRevenue {
  type: typeof types.FAIL_GET_MONTH_REVENUE;
  payload: APIFailedResponse;
}
export const failGetMonthRevenue = (payload: FailGetMonthRevenue['payload']) => ({
  type: types.FAIL_GET_MONTH_REVENUE,
  payload,
});

/**
 * Init state
 */
interface InitRevenue {
  type: typeof types.INIT_REVENUE;
}
export const initRevenue = () => ({
  type: types.INIT_REVENUE,
});
